var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 15"}},[_c('path',{attrs:{"fill":_vm.color,"d":"M15 7H9V1H7v6H1v2h6v6h2V9h6z"},on:{"click":function($event){return _vm.$emit('click')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }